module.exports = __webpack_public_path__ + "img/38.b7cd15f7.png";